async function resolveIncludes() {
  const placeholders = document.querySelectorAll("[data-include]");
  if (placeholders.length === 0) {
    return;
  }

  await Promise.all(
    Array.from(placeholders).map(async (placeholder) => {
      const url = placeholder.getAttribute("data-include");
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Failed to load ${url}: ${response.status}`);
        }
        placeholder.outerHTML = await response.text();
      } catch (error) {
        console.error(error);
      }
    }),
  );

  // Fetched content may itself contain [data-include] placeholders
  // (e.g. the footer layout include nests a newsletter section include).
  await resolveIncludes();
}

document.addEventListener("DOMContentLoaded", async () => {
  await resolveIncludes();
  document.dispatchEvent(new CustomEvent("sections:loaded"));
});
